export default __webpack_public_path__ + "static/home-c9b6020f42af9e42ad407cb689bfd967.jpeg";